export const zIndices = {
  chatDialog: 500,
  dialog: 1_001,
  menu: 200,
  modalBackdrop: 1_000,
  modalDialog: 1_001,
  navDrawer: 999,
  platformNavbar: 500,
  templateDrawer: 499,
  toaster: 9_999,
  toolbar: 100,
  tooltip: 300,
};
